import { render, staticRenderFns } from "./ClientsBrandsSidebar.vue?vue&type=template&id=01aadf57&"
import script from "./ClientsBrandsSidebar.vue?vue&type=script&lang=js&"
export * from "./ClientsBrandsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports